module.exports = __webpack_public_path__ + "static/media/tooltips_d_004.movie.4a9c9771.mp4";